import type { PlanId } from '../../../convex/billing/plans';
import s from './billing.module.scss';

export function PlanBadge({ plan }: { plan: PlanId }) {
  return (
    <span className={s.planBadge} data-plan={plan}>
      {plan.charAt(0).toUpperCase() + plan.slice(1)}
    </span>
  );
}
